import React, { ReactNode, useContext, useMemo, useRef, useState, useEffect } from 'react';
import { NavLink as _NavLink, useLocation } from 'react-router-dom';
import { collectSubMenus } from '@/components/slide-menu';
import ComponentLog from '@/components/component-log';
import provideSlideMenu from './provide-slide-menu';
import classnames from 'classnames';
import { connect } from 'react-redux';
import apis from '@/apis';
import { getGlobalGuideList } from '@/store/auto-guide';
import { takeOverScrollToTop } from '@/store/scroll-top';
import { message } from 'antd';
import AutoGuide from '@/components/auto-guide';
import { useHistory } from 'react-router-dom';
import { generatePath } from 'react-router-dom';
import _ from 'lodash';
import utils from '@/common/utils';

const NavLink: any = _NavLink;

// 获取对应子路由的link
function getLink(normalgetLink: any, { search, parentPath, path, linkParams }: { [index: string]: string }) {
  let to;
  if (normalgetLink) {
    to = normalgetLink({ search, parentPath, path });
  } else {
    to = path.indexOf('?') === -1 ? path + search : path;
  }
  if (linkParams && typeof linkParams == 'object') {
    try {
      to = generatePath(to, linkParams);
    } catch (ex) {
      console.error(ex);
    }
  }
  return to;
}

type linkParamsFn = (data: unknown) => object;

// 获取连接参数
function getLinkParams(linkParams: object | linkParamsFn | undefined, data: unknown) {
  if (!linkParams) return linkParams;
  if (_.isFunction(linkParams)) return linkParams(data);
  return linkParams;
}

function innerRenderTabNavItem({
  path,
  title,
  href,
  log,
}: {
  path: string;
  title: ReactNode;
  href: string;
  log?: string;
}): React.ReactNode {
  return title;
}

export enum TabNavItemType {
  link = 1, // 链接 不需要react-router自动补全前缀，使用标签a渲染
  native = 0, // 内部路由 使用标签Link渲染
}

export enum TabNavItemTarget {
  blank = 'blank',
  normal = '',
}

export interface menuItemsType {
  path: string;
  title: ReactNode;
  getlog?: () => string;
  itemType?: TabNavItemType;
  target?: TabNavItemTarget;
}

interface TabNavProps {
  filterMenus?: (menus: any) => any;
  alignCenter?: boolean;
  layout?: 'inline' | 'vertical'; // 菜单布局 "inline": 水平排列于一行 ， “vertical”：垂直排列
  sticky?: boolean; // 是否吸顶
  className?: string;
  linkEndWithSearch?: boolean;
  slideMenuContext?: any;
  renderExt?: () => React.ReactNode;
  renderTabNavItem?: typeof innerRenderTabNavItem;
  menuItems?: Array<menuItemsType>; // 传入的自定义路由
  list?: any;
  getGlobalGuideList: any;
  takeOverScrollToTop: any;
  linkParams?: any;
}

function TabNav(props: TabNavProps) {
  const {
    filterMenus = (menus: any) => menus,
    alignCenter = false,
    className,
    layout = 'inline',
    sticky = false,
    linkEndWithSearch = true,
    slideMenuContext,
    renderExt = () => null,
    renderTabNavItem = innerRenderTabNavItem,
    menuItems,
    linkParams, //aaa
  } = props;

  const planCode = utils.getQuery('planCode');
  const history = useHistory();
  const [hints, setHints] = useState([]);
  const value = useContext(slideMenuContext || provideSlideMenu);
  const globalGuideList = useRef(props.getGlobalGuideList);
  const takeOverScroll = useRef(props.takeOverScrollToTop);
  const subMenus =
    menuItems || // 两种传递子路由的方式 1：menuItems自定义路由，2：通过provideSlideMenu中的children获取
    filterMenus(collectSubMenus((value as any).children) || []).map((item: any) => {
      return { ...item.props };
    });

  let arr: any[] = [];
  subMenus.forEach((item: any) => {
    if (item.businessId) {
      arr.push(item.businessId);
    }
  });

  // 渲染tabnav右侧的额外元素
  const ext = useMemo(() => {
    if (renderExt == null) return null;
    if (typeof renderExt === 'function') return renderExt();
    if (React.isValidElement(renderExt)) return renderExt;
    return null;
  }, [renderExt]);

  const guideShowList = useMemo(() => {
    return props.list.map((item: any) => item.location.split('-').slice(-1)[0]);
  }, [props.list]);

  /* eslint-disable */
  useEffect(() => {
    let hintsII: any[] = [];
    if (props.list.length > 0) {
      props.list.forEach((item: any, index: any) => {
        if (item.type == 2 && item.location.split('-').length > 1 && item.locationType == 2) {
          if (arr.indexOf(Number(guideShowList[index])) !== -1) {
            setTimeout(() => {
              const element = document.querySelector(`a[data-new='id-${guideShowList[index]}']`);
              if (element !== null) {
                hintsII.push({
                  title: item.title,
                  element,
                  intro: item.content,
                  menuId: guideShowList[index],
                  button: item.button,
                  direction: layout !== 'inline' ? 'left' : 'bottom',
                });
              }
              setHints(Object.assign([], hintsII));
            }, 500);
          }
        }
      });
      if (hintsII.length <= 0) {
        setHints([]);
      }
    } else {
      setHints([]);
    }
  }, [...arr, props.list]);
  /* eslint-enable */

  /** 开始 -----------------
   *  在吸顶模式下，初始页面的scrollTop为0，当点击tab栏切换路由时，页面滚动至遮盖头部信息的高度，使tab栏紧贴屏幕顶部 */
  const tabNavRef = useRef<any>(null);
  const tabChanged = useRef(false); // 点击tab时默认用户想要切换子路由，但是还是要根据pathName的变化来决定
  const location = useLocation();
  const aRef = useRef(false); // 表示头部信息是否已完全遮盖
  // const scrollRef = useRef(0); // 滚动高度

  const onTabChange = () => {
    tabChanged.current = true;
    //记录此时的scrollTop，路由切换时，滚动的开始距离就是此刻记录的
    // scrollRef.current = document.documentElement.scrollTop;
    if (tabNavRef?.current?.offsetTop <= document.documentElement.scrollTop) {
      //此时表示头部信息已完全遮盖。路由切换时页面直接滚动到目的高度
      aRef.current = true;
    } else {
      // 头部信息未完全覆盖时，切换路由页面滚动执行缓动效果
      aRef.current = false;
    }
  };

  useEffect(() => {
    if (sticky) takeOverScroll.current({ takeOverscroll: true }); // 更新store，顶部滚动已经被接管，所有的路由切换滚动以当前吸顶为主
    if (tabChanged.current && sticky) {
      tabChanged.current = false;
      /*@ts-ignore */
      const targetOffsetTop = tabNavRef.current.offsetTop - 1; // 减1可以预防页面某些元素加载晚于scroll滚动结束，顶部元素被页面卷去
      // document.documentElement.scrollTop = scrollRef.current; // 因为系统在路由切换时总是让scrollTop =0，为了让滚动效果更加顺滑，需要提前设置页面滚动的开始距离为路由切换前的scrollTop
      if (aRef.current) {
        //头部信息完全遮盖时，直接到达目标高度
        window.scroll({ top: targetOffsetTop });
      } else {
        window.scrollTo({
          top: targetOffsetTop,
          behavior: 'smooth',
        });
      }
    }
  }, [location.pathname, sticky]);
  /** ------------------ 结束*/

  const needRenderExt = !!ext;

  if (!subMenus.length) return null;

  // 获取顶部导航的高度
  const { ACORE = { TOP_GLOBAL_NAV_HEIGHT: 0 } } = window;
  const top_nav_height = (ACORE as any).TOP_GLOBAL_NAV_HEIGHT;

  const scrollHeight = top_nav_height + 1;
  const scrollHeightStyle = () => {
    const _style: any = {};
    if (sticky) {
      _style.top = scrollHeight;
      _style.height = `calc(100vh - ${scrollHeight}px)`;
    }
    if (layout === 'vertical') {
      _style.minHeight = `calc(100vh - ${scrollHeight}px)`;
    }
    return _style;
  };

  // 通过linkEndWithSearch取消tab在path后拼接search的默认行为
  const search = linkEndWithSearch ? window.location.search : '';

  const navWrapClassnames = classnames('nav-sec-wrap', className, {
    'nav-align-center': alignCenter,
    'side-nav-container': !alignCenter,
    'nav-layout-inline': layout === 'inline',
    'nav-layout-vertical': layout === 'vertical',
    'nav-sticky': sticky,
  });

  function iSeeIt(businessId: any) {
    let currIndex = -1;
    guideShowList.forEach((item: any, index: any) => {
      if (item == businessId) {
        currIndex = index;
      }
    });
    if (Number(currIndex) >= 0) {
      apis
        .functionGuideGuide({ location: props.list[currIndex].location })
        .then((res: any) => {
          if (res && res.ret === '0') {
            globalGuideList.current();
            const ele = document.querySelector(`a[data-new='id-${guideShowList[currIndex]}']`);
            const url = (ele as HTMLEmbedElement)?.dataset?.guide || '';
            url && history.push(url);
          } else {
            message.error(res.msg);
          }
        })
        .catch((err) => {
          message.error(err);
        });
    }
  }

  function renderTag(item: any) {
    let url: any = '';
    let type: number | string = '';
    props.list.forEach((key: any, index: any) => {
      if (guideShowList[index] === String(item.businessId)) {
        if (key.planCode && planCode !== key.planCode) return null;
        type = key.type;
        if (key.type === 1) {
          url = '//img30.360buyimg.com/pop/jfs/t1/150315/19/21909/1858/620dfc9cEb4a7628d/6fa98dcaab6ce312.png';
        } else if (key.type === 3) {
          url = key.imageUrl;
        }
      }
    });
    return url ? (
      <img
        src={url}
        className={classnames('nav-sec-item-title-icon', { 'nav-sec-item-title-icon-custom': Number(type) == 3 })}
      />
    ) : null;
  }

  function hrefAndGetNewIcon(menuId: any) {
    let currIdFlag = '';
    props.list.forEach((obj: any) => {
      if (obj.type == 1 && obj.location.split('-').slice(-1)[0] == menuId) {
        currIdFlag = 'FUNC';
      }
    });
    if (currIdFlag === 'FUNC') {
      iSeeIt(menuId);
    }
  }

  return (
    <>
      {sticky && <div ref={tabNavRef} />}
      <div className={navWrapClassnames} id="acore-tab-nav-id" style={scrollHeightStyle()}>
        <div className="side-nav-links">
          {subMenus.map((item: any) => {
            const { getlog, relativePath, parentPath, path } = item;

            const innerLinkParams = getLinkParams(linkParams, item);
            const to = getLink(item.getLink, {
              search,
              path,
              parentPath,
              relativePath,
              linkParams: innerLinkParams as any,
            });
            const clstag = typeof getlog === 'function' ? getlog() : null;

            // TODO: 重构
            const itemLink =
              item.itemType === TabNavItemType.link ? (
                <a
                  data-new={`id-${item.businessId}`}
                  //@ts-ignore
                  clstag={clstag}
                  key={item.path}
                  className="nav-sec-item nav-sec-item-wrap"
                  href={to}
                  target={item.target || ''}
                  data-guide={to}
                  onClick={() => {
                    onTabChange();
                    hrefAndGetNewIcon(item.businessId);
                  }}
                >
                  <span className="nav-sec-item-title">
                    {renderTabNavItem({ path: item.path, title: item.title, href: to })}
                    <i style={{ paddingLeft: '6px', fontStyle: 'normal' }}>{'>'}</i>
                    {renderTag(item)}
                    {/* {isTag(item) && (
                      <img
                        src="//img30.360buyimg.com/pop/jfs/t1/150315/19/21909/1858/620dfc9cEb4a7628d/6fa98dcaab6ce312.png"
                        className="nav-sec-item-title-icon"
                      />
                    )} */}
                  </span>
                </a>
              ) : (
                <NavLink
                  data-new={`id-${item.businessId}`}
                  clstag={clstag}
                  key={item.path}
                  className="nav-sec-item"
                  activeClassName="nav-sec-item-act"
                  to={to}
                  target={item.target || ''}
                  data-guide={to}
                  onClick={() => {
                    onTabChange();
                    hrefAndGetNewIcon(item.businessId);
                  }}
                >
                  <span className="nav-sec-item-title">
                    {renderTabNavItem({ path: item.path, title: item.title, href: to })}
                    {renderTag(item)}
                    {/* {isTag(item) && (
                      <img
                        src="//img30.360buyimg.com/pop/jfs/t1/150315/19/21909/1858/620dfc9cEb4a7628d/6fa98dcaab6ce312.png"
                        className="nav-sec-item-title-icon"
                      />
                    )} */}
                  </span>
                </NavLink>
              );

            if (!clstag) return itemLink;

            return <ComponentLog key={item.path}>{itemLink}</ComponentLog>;
          })}
        </div>
        {needRenderExt && <div className="side-nav-ext">{ext}</div>}
        {hints.length > 0 && <AutoGuide hints={hints} iSeeIt={iSeeIt} />}
      </div>
    </>
  );
}

export default connect(
  (state: any) => {
    return {
      list: state.globalGuide.list,
    };
  },
  { getGlobalGuideList, takeOverScrollToTop }
)(TabNav);

export { provideSlideMenu };
